/**
 * Import React libraries.
 */
import * as React from 'react';

/**
 * Import third-party libraries.
 */
import styled from 'styled-components';

/**
 * Import custom components.
 */
import FooterBottomLinks from './Components/FooterBottomLinks';
import FooterTop from './Components/FooterTop';
import FooterNewsletterAndSocialSection from './Components/FooterNewsletterAndSocialSection';
import FooterNavSection from './Components/FooterNavSection';
import { BREAKPOINTS, COLORS } from '../styles';

/**
 * Import custom styles.
 */
import { NavLink, NavOptions } from '../types';
import {PageWidth} from "../Layouts";

const FooterContainer = styled.footer`
  margin-top: auto;
  background-color: ${COLORS.neutral_800};
  border-top: 8px solid ${COLORS.neutral_200};

  padding-top: 0;
  padding-bottom: 16px;

  ${BREAKPOINTS.MEDIUM} {
    padding: 16px 0;
  }

  ${BREAKPOINTS.LARGE} {
    padding: 16px 0;
  }
`;
const FooterLine = styled.div`
  border-top: 1px solid ${COLORS.white};
  display: none;
  ${BREAKPOINTS.MEDIUM} {
    display: block;
  }
`;

interface NewFooterProps  extends Omit<React.HTMLAttributes<HTMLElement>, 'id'> {
  id: string;
  sitename?: string;
  showBetaTag?: boolean;
  bottomLinks?: NavLink[];
  copyrightText?: string;
  includeNewsletterAndSocialSection?: boolean;
  actionOnNewsletterSignup?: (email: string) => void;
  newsletterLabel?: string;
  toTopText: string;
  navOptions?: NavOptions;
  placeholderEmailField?: string;
  onNewsletterSignup?: (email: string) => void;
  useMaxWidth?: boolean;
  maxWidth?: number;
}

const SiteFooter = ({
  id,
  sitename,
  bottomLinks,
  showBetaTag,
  copyrightText,
  toTopText,
  placeholderEmailField,
  includeNewsletterAndSocialSection,
  newsletterLabel,
  navOptions,
  onNewsletterSignup,
  useMaxWidth = true,
  maxWidth,
  ...rest
}: NewFooterProps) => {
  return (
    <FooterContainer id={id} data-testid={'footer-container'} {...rest}>
      <PageWidth unsetMargin={true} useMaxWidth={useMaxWidth} maxWidth={maxWidth}>
        <FooterTop sitename={sitename} showBetaTag={showBetaTag} toTopText={toTopText} />
        {navOptions && <FooterNavSection mainId={id} navOptions={navOptions} />}
        <FooterLine />
        {includeNewsletterAndSocialSection && (
          <FooterNewsletterAndSocialSection placeholderEmail={placeholderEmailField} actionOnNewsletterSignup={onNewsletterSignup} newsletterLabel={newsletterLabel || ''} />
        )}
        <FooterBottomLinks bottomLinks={bottomLinks} copyrightText={copyrightText} />
      </PageWidth>
    </FooterContainer>
  );
};

export default SiteFooter;
